import { useTranslation } from 'react-i18next';
import { Button, Icon } from 'shell/components';

const FeedbackRevertButton = ({ canRevert, itemIds, pending, onRevertFeedback }) => {
    const { t } = useTranslation('assignment');
    if (!canRevert || typeof onRevertFeedback !== 'function') return null;

    return (
        <Button
            sx={{ ml: 'auto', flexShrink: 0 }}
            aria-label={t('grading-section.feedback-revert-previous', 'Revert to previous')}
            disabled={pending}
            startIcon={<Icon kind={'refresh'} />}
            variant={'tertiary'}
            onClick={(event) => {
                event.stopPropagation();
                onRevertFeedback(itemIds);
            }}
        >
            {t('grading-section.feedback-revert', 'Revert')}
        </Button>
    );
};

export default FeedbackRevertButton;
